import { useMutation, useQueryClient } from '@tanstack/react-query'

import client from '~/clients/api-client'

import { handleApiRequest } from '../../optimus/shared/apiWrapper'

export const useResetSelectedViewOptionProfile = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async (page_type: string) => handleApiRequest(() => client.viewOptionProfiles.reset(page_type)),
        retry: 0,
        onSuccess: async () => {
            // invalidate view option profiles list query to refetch updated profiles
            await queryClient.invalidateQueries({ queryKey: ['viewOptionProfiles'] })
        },
    })
}
